<template>
  <div class="com-rule-page">
    <div class="rule_content" v-html="activityRule"></div>
    <div class="bottom_float_btn">
      <button @click="back">返回</button>
    </div>
  </div>
</template>

<script>
import { getPageInfo, getInvitee } from '../api';
import { stringifyQuery } from '@/utils';
import { mapMutations, mapActions } from 'vuex';
export default {
  data() {
    return {
      activityRule: ''
    };
  },
  async mounted() {
    await this.loadLocationData(true);
    let { inviteUserType } = this.$route.query;
    console.log(inviteUserType, 'inviteUserType---->');
    if (inviteUserType) {
      this.getInvitee();
      return;
    }
    this.trackLogHandle(inviteUserType);
    this.getPageInfo();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'login') {
      let query = this.$route.query;
      if (query.user_type) {
        to.params.redirectObject = {
          path: `/rule?${stringifyQuery(query)}`
        };
      }
    }
    next();
  },
  methods: {
    ...mapMutations('global', ['set_env']),
    ...mapActions('app', ['fetchPageInfo', 'loadLocationData']),
    trackLogHandle(inviteUserType) {
      if (!inviteUserType) return;
      this.trackLog('规则页', false, {
        actEventType: 'invite_rule_expo'
      });
    },
    getInvitee() {
      getInvitee().then(res => {
        this.activityRule = res.activityRule;
      });
    },
    getPageInfo() {
      getPageInfo().then(res => {
        this.activityRule = res.activityRule;
      });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.com-rule-page {
  width: 750px;
  padding-bottom: 206px;
  background: #f3f4f5;
  position: relative;
  .fcc;
  padding-top: 34px;
  .rule_content {
    width: 696px;
    padding: 34px 38px 55px 38px;
    margin-bottom: 24px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 32px;
    color: #181d37;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
    h3 {
      font-size: 44px;
      margin-bottom: 27px;
    }
    /deep/ p,
    /deep/ ol {
      font-size: 28px;
      opacity: 0.85;
      line-height: 54px;
      font {
        &[size='1'] {
          font-size: 20px;
        }
        &[size='2'] {
          font-size: 26px;
        }
        &[size='3'] {
          font-size: 32px;
        }
        &[size='4'] {
          font-size: 36px;
        }
        &[size='5'] {
          font-size: 48px;
        }
        &[size='6'] {
          font-size: 64px;
        }
        &[size='7'] {
          font-size: 96px;
        }
      }
    }
  }
  .bottom_float_btn {
    width: 750px;
    height: 276px;
    opacity: 1;
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    .fc;
    padding-bottom: 0; //适配iPhoneX
    padding-bottom: constant(safe-area-inset-bottom); //适配iPhoneX
    padding-bottom: env(safe-area-inset-bottom); //适配iPhoneX
    bottom: 0;
    background: linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 1)
    );
    border-radius: 0 0 32px 32px;
    button {
      width: 623px;
      height: 106px;
      background: #ff6816;
      border-radius: 20px;
      font-size: 42px;
      color: #fff;
    }
  }
}
</style>
